import React from "react";
import logo from "../../assets/images/logo.png";
import "./style.css";
import { ToastContainer } from "react-toastify";
function LoginUi({
  phoneNumber,
  errors,
  touched,
  onphoneNumberChange,
  onSubmit,
  otp,
  onOtpChange,
  timeLeft,
  resendEnabled,
  handleResendOtp,
  showOtp,
  termsAccepted,
  onTermsChange,
  snackbar,
  resStatus,
}) {
  const handleOtpInputChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      onOtpChange(newOtp.join(""));
    }
  };

  const handleKeyUp = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    } else if (index < 5 && otp[index]) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  return (
    <div>
      <div className="login-page-css">
        <div className="d-flex mt-4">
          <div className="login-logo">
            <img style={{ height: "60px" }} src={logo} alt="" />
          </div>
          <div className="ml-2">
            <h4 className="mt-1 mb-0  heading">Railway Recruitment Board</h4>
            <h6 className="logo-sub-text">
              Government of India, Ministry of Railways
            </h6>
          </div>
        </div>

        <div className="login-box login-h-w">
          <div className="card h-100 w-100 d-inline-block rounded-3 card-bord">
            <div className="card-body login-card-body rounded-3">
              <h4 className="mt-1 text-center heading">Welcome Back</h4>
              <p className="login-box-msg sub_heading">
                Please verify your mobile number to continue
              </p>
              {/* <ToastContainer containerId={"login-form"} /> */}
              {snackbar ? (
                resStatus == "success" ? (
                  <div className="mb-3 success-box">
                    <p>{snackbar}</p>
                  </div>
                ) : (
                  <div className="err-box mb-3">
                    <p>{snackbar}</p>
                  </div>
                )
              ) : null}

              <form onSubmit={onSubmit} method="post">
                <div className="mb-1">
                  <span className="label-text">Mobile Number</span>
                </div>
                <div className="d-flex ">
                  <div className="input-group-append">
                    <div className=" contry-code">+91</div>
                  </div>
                  <input
                    autocomplete="off"
                    type="tel"
                    className="form-control-phonenumber"
                    placeholder="Enter your mobile number"
                    value={phoneNumber}
                    onChange={onphoneNumberChange}
                    onInput={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      e.target.value = value.slice(0, 10); // Limit to 10 digits
                    }}
                  />
                </div>
                <div>
                  {touched.phoneNumber && errors.phoneNumber && (
                    <span className="text-danger mb-2 error-text">
                      {errors.phoneNumber}
                    </span>
                  )}
                  {showOtp ? (
                    <>
                      <div className="mb-1 mt-3">
                        <span className="label-text">OTP</span>
                      </div>
                      <div className="otp-input-group mb-2 d-flex justify-content-between align-items-center">
                        {[0, 1, 2, 3, 4, 5]?.map((index) => (
                          <input
                            autocomplete="off"
                            key={index}
                            autoFocus={index === 0} 
                            id={`otp-input-${index}`}
                            type="text"
                            className="otp-input-box"
                            maxLength="1"
                            value={otp[index] || ""}
                            onChange={(e) =>
                              handleOtpInputChange(index, e.target.value)
                            }
                            onKeyUp={(e) => handleKeyUp(e, index)}
                          />
                        ))}
                      </div>
                      {touched.otp && errors.otp && (
                        <span className="text-danger mb-2 error-text">
                          {errors.otp}
                        </span>
                      )}
                      {timeLeft > 0 ? (
                        <div className=" d-flex justify-content-start">
                          <span className="checkbox-label">
                            Resend OTP in {timeLeft}s
                          </span>
                        </div>
                      ) : (
                        <div className=" d-flex justify-content-start">
                          <button
                            type="button"
                            className="resend-otp-btn"
                            onClick={() => handleResendOtp(phoneNumber)}
                            disabled={!resendEnabled}
                          >
                            Resend OTP
                          </button>
                        </div>
                      )}
                    </>
                  ) : null}
                  {/* <div className="d-flex  align-items mt-3 checkbox-div">
                    <label htmlFor="checkbox" className="d-flex align-items">
                      <input
                        type="checkbox"
                        name="termsAccepted"
                        checked={termsAccepted}
                        onChange={onTermsChange}
                        className="mr-2"
                        id="checkbox"
                      />
                      <span className="checkbox-label">
                        I agree to the Terms and Conditions
                      </span>
                    </label>
                  </div> */}
                  {/* {touched.termsAccepted && errors.termsAccepted && (
                    <span className="text-danger mb-2 error-text">
                      {errors.termsAccepted}
                    </span>
                  )} */}
                  <div className=" mt-3">
                    <button type="submit" className="submit-button">
                      {showOtp ? "Verify & Sign In" : "Sign In"}
                    </button>
                  </div>
                  {/* <div className="d-flex justify-content-center align-items-end mt-3">
                    <p className="support-text">
                      Need help?<span>Contact support</span>
                    </p>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
        <h6 className="logo-bottom-text text-center mt-3">
          Copyright © {new Date().getFullYear()}, Railway Recruitment Board.
          <br></br> All Rights Reserved.
        </h6>
      </div>
    </div>
  );
}

export default LoginUi;
